<template>
  <Carousel>
    <Slide v-for="slide in slides" :key="slide">
      <div class="carousel__item">
        <img
          :src="require(`@/assets/carousel/${slide.src}`)"
          alt="submenu image"
          :style="{
            height: '100%',
            width: '100%',
            borderRadius: 8 + 'px',
          }"
        />
      </div>
      <div class="subtitle-base">
        <p class="subtitle">{{ slide.subtitle }}</p>
      </div>
    </Slide>
    <template #addons>
      <Pagination />
      <Navigation />
    </template>
  </Carousel>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "CarouselHome",
  components: {
    Pagination,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    slides: [
      { src: "manuka.jpg", subtitle: "Manuka Tree - Tea Tree" },
      { src: "lupin.jpg", subtitle: "Lupin Field" },
      { src: "karo01.jpg", subtitle: "Karo Tree" },
      { src: "leptolepia03.jpg", subtitle: "One of many fern of New-Zealand" },
      { src: "metrosideros_collina02.jpg", subtitle: "Puarata - Spring Fire" },
    ],
  }),
});
</script>

<style lang="scss" scoped>
.carousel__next{
  svg {
    title {
      
    }
  }

}
.carousel__item {
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-size: 20px;
  justify-content: center;
  max-height: 360px;
  width: 100%;
}
.carousel__slide {
  margin: 0;
}
.subtitle-base {
  display: none;
  @media (min-width: $constraint-width-medium) {
    max-height: 250px;
    display: flex;
  }
  bottom: 20px;
  margin-left: 50px;
  max-width: 960px;
  position: relative;
}
.subtitle {
  background-color: rgba(255, 255, 255, 0.8);
  color: #575757;
  font-weight: 600;
  padding: 0.5em 0.8em 0.5em 0.8em;
  display: block;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-left: 25px;
  width: fit-content;

  @media (min-width: $constraint-width-medium) {
    font-size: 1.5rem;
  }
  @media (min-width: $constraint-width-large) {
    font-size: 2rem;
  }
  @media (min-width: $constraint-width-x-large) {
    font-size: 2.5rem;
  }
}
</style>
